// extracted by mini-css-extract-plugin
export default {"container":"nKoaKs","page":"HBar8X"};